import {cva} from 'class-variance-authority';

/** sm: confirmations · md: short forms · lg: two-column or single-column multi-step · xl: wide forms · 2xl: list + form, tables · full: document viewer. */
export const modalSizeVariantsConfig = {
  variants: {
    size: {
      sm: 'sm:max-w-100',
      md: 'sm:max-w-140',
      lg: 'sm:max-w-180',
      xl: 'sm:max-w-4xl',
      '2xl': 'sm:max-w-5xl',
      full: 'sm:max-w-none'
    }
  },
  defaultVariants: {
    size: 'md'
  }
} as const;

export const modalSizeVariants = cva('', modalSizeVariantsConfig);

export const modalHeaderVariantsConfig = {
  default: {header: 'gap-4', text: 'gap-1', title: 'text-base', description: ''},
  hero: {
    header: 'gap-3.5',
    text: 'gap-2',
    title: 'text-xl leading-6.5',
    description: 'max-w-90 leading-normal'
  }
} as const;
